import { makeRouteMap, makeUseNavigate } from 'toolbox';
import { makeUseParamsAndSearch } from 'toolbox/src/utils/makeUseNavigate';

export const routeMap = makeRouteMap({
  root: {
    path: '/',
  },
  home: {
    path: '/home',
  },
  authenticatorRoot: {
    path: '/auth',
  },
  confirmSignUp: {
    path: '/auth/confirm-signup',
    search: {
      username: true,
    },
  },
  register: {
    path: '/auth/register',
  },
  viewBankById: {
    path: '/admin/banks/:id',
    params: {
      id: true,
    },
  },
  newBank: {
    path: '/admin/banks/new',
  },
  reports: {
    path: '/reports',
  },
  research: {
    path: '/research',
  },
  factsheets: {
    path: '/factsheets',
  },
  books: {
    path: '/admin/books',
  },
  settings: {
    path: '/settings',
  },
  error: {
    path: '/error/:type',
    params: {
      type: true,
    },
  },
  viewOrgs: {
    path: '/admin/orgs',
  },
  viewOrgById: {
    path: '/admin/orgs/:id',
    params: {
      id: true,
    },
  },
  createBusinessUnit: {
    path: '/admin/business-units/new',
    search: {
      orgId: true,
    },
  },
  viewBusinessUnit: {
    path: '/admin/business-units/:id',
    params: {
      id: true,
    },
  },
  viewBanks: {
    path: '/admin/banks',
  },
  viewUsers: {
    path: '/admin/users',
  },
  adminResearch: {
    path: '/admin/research',
  },
  viewCurrencyBookById: {
    path: '/admin/books/:id',
    params: {
      id: true,
    },
  },
  newCurrencyBook: {
    path: '/admin/books/new',
    search: {
      businessUnitId: true,
    },
  },
  newOrg: {
    path: '/admin/orgs/new',
  },
  adminViewBankAccounts: {
    path: '/admin/bank-accounts',
  },
  createBankAccount: {
    path: '/admin/bank-accounts/new',
    search: {
      orgId: true,
      buId: true,
      cbId: true,
      ccyId: true,
    },
  },
  viewBankAccountById: {
    path: '/admin/bank-accounts/:account_id',
    params: {
      account_id: true,
    },
  },
  adminViewBalances: {
    path: '/admin/balances',
  },
  adminUploadBalances: {
    path: '/admin/balances/upload',
  },
});

export const useNavigate = makeUseNavigate(routeMap);

export const useParamsAndSearch = makeUseParamsAndSearch(routeMap);
